/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportLotInputLotItemsInner
 */
export interface TransportLotInputLotItemsInner {
    /**
     * 商品コード
     * @type {string}
     * @memberof TransportLotInputLotItemsInner
     */
    itemCode: string;
    /**
     * 積載ケース数
     * @type {number}
     * @memberof TransportLotInputLotItemsInner
     */
    lotQuantity: number;
}

/**
 * Check if a given object implements the TransportLotInputLotItemsInner interface.
 */
export function instanceOfTransportLotInputLotItemsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "itemCode" in value;
    isInstance = isInstance && "lotQuantity" in value;

    return isInstance;
}

export function TransportLotInputLotItemsInnerFromJSON(json: any): TransportLotInputLotItemsInner {
    return TransportLotInputLotItemsInnerFromJSONTyped(json, false);
}

export function TransportLotInputLotItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportLotInputLotItemsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'itemCode': json['item_code'],
        'lotQuantity': json['lot_quantity'],
    };
}

export function TransportLotInputLotItemsInnerToJSON(value?: TransportLotInputLotItemsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item_code': value.itemCode,
        'lot_quantity': value.lotQuantity,
    };
}

